import { faPlus } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import ComingSoonPage from './ComingSoonPage'

export default function Subcription() {

    return (
        <div className='mt-5' data-aos='fade-in' data-aos-duration='1000'>
            <ComingSoonPage />
            <p className='text-xl font-medium tracking-widest uppercase'>SUBSCRIPTION PAYEMNTS</p>
            <div className='mt-8 flex flex-col lg:flex-row gap-5 lg:gap-7'>
                <div className='w-[100%] lg:w-[50%] px-5 lg:px-10 py-5 lg:py-8 rounded-3xl bg-no-repeat bg-cover bg-center relative' style={{ backgroundImage: "url('/assets/others/creditcard.svg')" }}>
                    <p className='uppercase font-medium'>Main Balance</p>
                    <p className='font-semibold text-3xl mt-2'>$673,412.66</p>
                    <div className='mt-7 flex items-center justify-between'>
                        <div className='flex'><div className='w-10 h-10 bg-white/50 rounded-full'></div><div className='-translate-x-3 w-10 h-10 bg-white/50 rounded-full'></div></div>
                        <p className='text-lg font-medium tracking-wider'>************ 1234</p>
                    </div>
                    <div className='mt-7 flex gap-10'>
                        <div>
                            <p className='text-[#7DCCF0] font-semibold'>VALID THRU</p>
                            <p className='font-medium mt-2'>08/21</p>
                        </div>
                        <div>
                            <p className='text-[#7DCCF0] font-semibold'>CARD HOLDER</p>
                            <p className='font-medium mt-2'>Franklin Jr.</p>
                        </div>
                    </div>
                    <div className='absolute -top-12 -right-6'>
                        <p className='text-sm font-medium'>ADD CARD</p>
                        <div className='mt-1 mx-auto bg-white w-14 h-14 rounded-full grid place-content-center cursor-pointer'>
                            <FontAwesomeIcon icon={faPlus} className='text-3xl text-[#41C6FF] font-bold' />
                        </div>
                    </div>
                </div>
                <div className='w-[100%] lg:w-[50%] px-5 lg:px-10 py-5 lg:py-8 rounded-3xl bg-white/10 grid content-between'>
                    <div className='flex flex-col lg:flex-row items-center justify-between text-center lg:text-start gap-3'>
                        <div>
                            <p className='font-medium'>YOUR CURRENT PLAN</p>
                            <p className='font-bold mt-2 text-3xl lg:text-5xl'>$1000</p>
                        </div>
                        <div className='text-center lg:text-end'>
                            <p>TOTAL PAYMENTS : <span className='font-semibold'>8</span></p>
                            <button className='mt-2 underline text-sm'>VIEW TRANSACTIONS </button>
                        </div>
                    </div>
                    <div className='mt-14 flex flex-col lg:flex-row gap-3 items-center justify-between'>
                        <div className='font-medium'>
                            <p>LAST PAYMENT</p>
                            <p className='mt-2'>FEB 26TH 2025 4:30 PM</p>
                        </div>
                        <button className='bg-[#5C1FE2] px-5 py-2 rounded-md text-sm'>MANAGE SUBSCRIPTION PLANS</button>
                    </div>
                </div>
            </div>
        </div>
    )
}
